let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("k7It5")).then(() => parcelRequire('5ozG8'));